export function sortByName<T extends { name: string }>(a: T, b: T): number {
  return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
}
